import { types } from 'mobx-state-tree';

const ProductTypeClass = {
  PHYSICAL: 'PHYSICAL',
  PAYMENT_COST: 'PAYMENT_COST',
  SHIPPING_COST: 'SHIPPING_COST',
  DISCOUNT: 'DISCOUNT',
  SERVICE: 'SERVICE',
  BOTTLE_DEPOSIT: 'BOTTLE_DEPOSIT',
  LOW_ORDER_FEE: 'LOW_ORDER_FEE'
};

export default ProductTypeClass;

export const ProductType = types.enumeration(
  'ProductTypeClass',
  Object.values(ProductTypeClass)
);



// WEBPACK FOOTER //
// ./src/types/ProductTypeClass.js